import { render, staticRenderFns } from "./ListTransferMedicals.vue?vue&type=template&id=b335e7b8&scoped=true&"
import script from "./ListTransferMedicals.vue?vue&type=script&lang=ts&"
export * from "./ListTransferMedicals.vue?vue&type=script&lang=ts&"
import style0 from "./ListTransferMedicals.vue?vue&type=style&index=0&id=b335e7b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b335e7b8",
  null
  
)

export default component.exports